module.exports = __webpack_public_path__ + "static/media/txt.b8c2e425.svg";